import _parseNumber from '../parse.js';
import normalizeArguments from '../normalizeArguments.js';
export default function parseNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return _parseNumber(text, options, metadata);
}
//# sourceMappingURL=parse.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/legacy/parse.js
// module id = 387
// module chunks = 22